// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    if (!props.apiResult?.order.orderLines?.some(o => !!o.productId)) {
        props.apiResult = undefined;
        return false;
    }

    // Store Custom Code - repeated from PopulateApiParameter to include another property in the cartLines
    props.apiParameter = {
        cartLines: props.apiResult.order.orderLines.map(
            line =>
                ({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                    // Store Custom Code
                    properties: { artSelection: line.properties.artSelection },
                } as unknown as CartLineModel),
        ),
    } as CartLineCollectionModel;
});
